<!-- Main landing page for the application-->
<!-- Loader-->

<!-- end of loader -->
<ng-container>
<div style="overflow-x: clip;" >
<div style="margin:0px;padding: 0px">
	<div class="row">
		<div class="col-sm-12">
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320" style="height: 365px;">
			<defs>
                <linearGradient id="grad3" x1="0%" y1="0%" x2="100%" y2="0%">
                  <stop offset="0%" style="stop-color:#600;stop-opacity:1" />
                  <stop offset="90%" style="stop-color:#006;stop-opacity:1" />
                </linearGradient>
            </defs>
			  <path fill="url(#grad3)"  fill-opacity="1" d="M0,160L60,154.7C120,149,240,139,360,138.7C480,139,600,149,720,165.3C840,181,960,203,1080,224C1200,245,1320,267,1380,277.3L1440,288L1440,0L1380,0C1320,0,1200,0,1080,0C960,0,840,0,720,0C600,0,480,0,360,0C240,0,120,0,60,0L0,0Z"></path>
			</svg>
			<div class="about-card">
			<div style="text-align: center;">
			    <hr class="break-hr">
			    <h3 class="about-head"> About Us </h3>
			    <hr class="break-hr">
			</div>
			<p class="about-content">SNAM Alloys Pvt Ltd., is one of the fastest growing and largest producer of Value Added Ferro Alloys in the world. With 30 years national and international presence in over 40 countries and 6 continents around the world, SNAM today is the undisputed producer in India and Asia to collectively manufacture Ferro Silicon, Ferro Silicon Magnesium &amp; Ferro Silicon based
Inoculants. Leading automotive and engineering foundries spanning across the globe go for the trusted and reliable SNAM products to address their critical requirements.</p>
            <a href="" >
                <button class="btn btn-md btn-primary text-uppercase" style="position: absolute;right: 75px;" >Contact us</button>
            </a>
		</div>
		</div>
		
	</div>
</div>
</div>  
</ng-container>

<!-- end of form for sign up-->
<style>
	.about-card{
		z-index: auto;
	}
</style>